import sumBy from 'lodash/sumBy';
import { arrayOf, number, shape } from 'prop-types';
import React from 'react';
import { Input, Label } from 'reactstrap';

import { attachmentContentTypeShape, attachmentShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import getEventTargetValue from '../../utils/get-event-target-value';
import AddAttachmentButton from '../AddAttachmentButton';
import { addFile, groupAttachments, removeFile } from '../utils';
import SmartCategorizedAttachmentsLayout from './SmartCategorizedAttachmentsLayout';

export class ListAttachmentsComponent extends React.Component {
  state = {
    attachments: groupAttachments(this.props.attachments),
    searchTerm: '',
  };

  handleSearchTermChange = e => {
    const searchTerm = getEventTargetValue(e.target);
    const { attachments } = this.props;
    const filteredAttachments = searchTerm
      ? attachments.filter(({ name }) =>
          name.toLowerCase().includes(searchTerm.toLowerCase()),
        )
      : attachments;
    this.setState({
      searchTerm,
      attachments: groupAttachments(filteredAttachments),
    });
  };

  getAttachmentsCount() {
    return sumBy(Object.values(this.state.attachments), 'length');
  }

  addFile = file => {
    this.setState(state => ({
      attachments: addFile(state.attachments, file),
    }));
  };

  removeFileFromGroup = file => {
    this.setState(state => ({
      attachments: removeFile(state.attachments, file),
    }));
  };

  render() {
    const { contentType, objectId } = this.props;
    const { attachments, searchTerm } = this.state;
    const attachmentsCount = this.getAttachmentsCount();
    const allAttachmentsCount = this.props.attachments.length;

    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="m-0">
            Attachments (
            {searchTerm
              ? `${attachmentsCount}/${allAttachmentsCount}`
              : allAttachmentsCount}
            )
          </h4>
          <Label className="text-nowrap m-0">
            Search by name
            <Input
              value={searchTerm}
              name="attachmentNameSearchTerm"
              className="d-inline ml-3"
              onChange={this.handleSearchTermChange}
            />
          </Label>
          <AddAttachmentButton
            contentType={contentType}
            objectId={objectId}
            onSuccess={this.addFile}
          />
        </div>
        {attachmentsCount > 0 ? (
          <SmartCategorizedAttachmentsLayout
            onDeleteFileSuccess={this.removeFileFromGroup}
            attachments={attachments}
          />
        ) : (
          'No attachments'
        )}
      </div>
    );
  }
}

ListAttachmentsComponent.propTypes = {
  attachments: arrayOf(attachmentShape.isRequired).isRequired,
  contentType: attachmentContentTypeShape.isRequired,
  objectId: number.isRequired,
};

const ListAttachments = withResolved({
  query: api.getAttachments,
  deriveQueryArgs: ({ search, contentType, objectId }) => ({
    search: search || { contentType, objectId },
  }),
  as: 'attachments',
})(ListAttachmentsComponent);

ListAttachments.propTypes = {
  search: shape({ accountId: number.isRequired }),
  contentType: attachmentContentTypeShape.isRequired,
  objectId: number.isRequired,
};

export default ListAttachments;
